import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BriefListingCard from 'components/BriefListingCard/BriefListingCard';
import JobListing from 'components/JobListing/JobListing';
import Loader from 'components/Loader/Loader';
import noActivity from './no-activity.png';
import JobsBoardBanner from '../../containers/Ads/JobsBoardBanner/JobsBoardBanner';
import SignUp from 'components/SignUp/SignUp';
import useAuth from 'hooks/useAuth';
import ApplicationWriterUpsell from 'components/ApplicationWriterUpsell/ApplicationWriterUpsell';
import UpsellSignUp from 'components/Upsell/UpsellSignUp';
import PostJobUpsell from 'components/PostJobUpsell/PostJobUpsell';
import { fromSeoUrl } from 'helpers/HelperFunctions';

const BriefListings = ({
  briefs,
  loaded,
  loading,
  selectedRole,
  paid,
  onClickRole,
  onClickLocation,
  onShowSignUpModal,
  country,
  city,
  partners,
  loadedPartners,
  loadingPartners,
  ...rest
}) => {
  const { user } = useAuth();

  const showUpsell = !user || (user && user?.pro === false);
  const role =
    selectedRole && selectedRole.name ? fromSeoUrl(selectedRole.name) : '';
  let jobsBoardBannerCount = 0;
  const maxBannerCount = 5;

  return (
    <div {...rest}>
      {loaded ? (
        <div>
          {briefs.length > 0 ? (
            <div>
              {briefs.map((brief, idx) => {
                if (
                  (idx === 1 || (idx + 1) % 15 === 0) &&
                  jobsBoardBannerCount <= maxBannerCount
                ) {
                  jobsBoardBannerCount++;
                }

                const briefListing = (
                  <JobListing
                    brief={brief}
                    key={brief.id}
                    onClickRole={onClickRole}
                    onClickLocation={onClickLocation}
                    onShowSignUpModal={onShowSignUpModal}
                  />
                );

                return (idx === 1 || (idx + 1) % 15 === 0) &&
                  jobsBoardBannerCount <= maxBannerCount ? (
                  <Fragment key={`briefListing-${brief.id}`}>
                    {briefListing}
                    <JobsBoardBanner
                      partners={partners}
                      loadedPartners={loadedPartners}
                      loadingPartners={loadingPartners}
                    />
                  </Fragment>
                ) : idx === 4 && showUpsell ? (
                  <Fragment key={`briefListing-${brief.id}`}>
                    {briefListing}
                    <UpsellSignUp user={user} mobile={true} />
                  </Fragment>
                ) : idx === 9 ? (
                  <Fragment key={`briefListing-${brief.id}`}>
                    {briefListing}
                    <ApplicationWriterUpsell user={user} mobile={true} />
                  </Fragment>
                ) : idx === 19 ? (
                  <Fragment key={`briefListing-${brief.id}`}>
                    {briefListing}
                    <PostJobUpsell
                      mobile={true}
                      role={role}
                      country={country}
                      city={city}
                    />
                  </Fragment>
                ) : (
                  briefListing
                );
              })}
            </div>
          ) : (
            <div className="mt++ text-center">
              <img src={noActivity} alt="Twine" />
              <p className="mt++">
                No
                {selectedRole !== null
                  ? ` ${selectedRole.name.toLowerCase()}`
                  : ''}{' '}
                {paid ? 'jobs' : 'collaborations'} found.
              </p>
              {!user ? (
                <>
                  <p>
                    Sign up to Twine below for free and get notified instantly
                    when jobs are available.
                  </p>
                  <SignUp
                    redirect={'onboarding'}
                    redirectFromGoogle={'signup'}
                    defaultAccountType={'seller'}
                  />
                </>
              ) : (
                <>
                  <p>
                    Turn on <a href="/settings">job alert notifications</a> to
                    be notified when the next job is posted.
                  </p>
                  <p>
                    <a href="/pricing/creatives">Upgrade to Twine Pro</a> to
                    increase your chances of winning work.
                  </p>
                </>
              )}
            </div>
          )}
          <Loader loading={loading} />
        </div>
      ) : (
        [...Array(3)].map((_, idx) => (
          <BriefListingCard brief={null} key={idx} />
        ))
      )}
    </div>
  );
};

BriefListings.propTypes = {
  briefs: PropTypes.array,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  selectedRole: PropTypes.object,
  paid: PropTypes.bool,
  onClickRole: PropTypes.func,
  onClickLocation: PropTypes.func,
  onShowSignUpModal: PropTypes.func,
  country: PropTypes.string,
  city: PropTypes.string,
  partners: PropTypes.array,
  loadedPartners: PropTypes.bool,
  loadingPartners: PropTypes.bool,
};

export default BriefListings;
